import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  // "active" mirrors the server-rendered state (default-expanded lists
  // carry it too); "user-opened" only ever comes from a click, letting
  // the CSS single out the list the reader is actually exploring.
  setActive(event) {
    if (event.currentTarget.contains(event.target)) {
      const activeItem = event.target.closest("details")
      if (!activeItem.open) {
        this.#deactivateParents(activeItem)
        activeItem.classList.add("active", "user-opened")
      } else {
        activeItem.classList.remove("active", "user-opened")
        const parent = activeItem.parentNode.closest("details")
        activeItem.querySelectorAll("details").forEach(details => {
          details.removeAttribute("open")
          details.classList.remove("active", "user-opened")
        })
        if (parent?.querySelectorAll("details.expandable-properties-list.active").length < 1) {
          parent.classList.add("active", "user-opened")
        }
      }
    }
  }

  #deactivateParents(container) {
    const parent = container.parentNode.closest("details")
    if (!parent) {
      return false
    }

    parent.classList.remove("active", "user-opened")
    return this.#deactivateParents(parent)
  }
}
